"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _webrtcAdapter = _interopRequireDefault(require("webrtc-adapter"));

var _webcom = _interopRequireDefault(require("webcom/webcom"));

var _console;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

/**
 * The current browser's infos
 * @typedef {Object} Browser
 * @property {string} name - current browser's name
 * @property {number} [version] - current browser's version
 * @property {number} [minVersion] - current browser's minimum supported version
 * @property {boolean} compatible - is current browser supported ?
 */
var browser = Object.assign({
  compatible: !/\s/.test(_webrtcAdapter.default.browserDetails.browser) && (!_webrtcAdapter.default.browserDetails.minVersion || _webrtcAdapter.default.browserDetails.version >= _webrtcAdapter.default.browserDetails.minVersion)
}, _webrtcAdapter.default.browserDetails);
var version = "Reach v".concat(SDK_VERSION, " | Schema ").concat(SCHEMA_VERSION, " | Webcom v").concat(_webcom.default.SDK_VERSION); // eslint-disable-line no-undef

var message = '';

if (browser.version === null) {
  message = 'Unsupported browser: browser must support WebRTC Peer-to-peer connections to use Reach';
} else if (browser.minVersion && browser.minVersion > browser.version) {
  message = "Unsupported browser: browser is outdated, update to latest version (".concat(browser.minVersion, "+)");
} else if (!_webrtcAdapter.default.browserShim) {
  message = 'No shim for your browser. There might a problem with your package.';
} // Log browser status & SDKs versions on load


var args = ["".concat(version, " ").concat(message)];

if (/^(chrome|firefox)$/.test(browser.browser)) {
  args = ["%c ".concat(version, " %c ").concat(message), "background: ".concat(browser.compatible ? '#f50' : 'red', "; color: #fff; font-weight: bold"), "color: ".concat(browser.compatible ? 'inherit' : 'red')];
}

(_console = console).log.apply(_console, _toConsumableArray(args)); // eslint-disable-line no-console


var _default = browser;
exports.default = _default;